import configuration from "@intlayer/config/built";
import { deepTransformNode } from "./deepTransform.mjs";
import {
  conditionPlugin,
  enumerationPlugin,
  filePlugin,
  insertionPlugin,
  nestedPlugin,
  translationPlugin
} from "./plugins.mjs";
const getContent = (node, nodeProps, locale = configuration?.internationalization.defaultLocale) => {
  const plugins = [
    insertionPlugin,
    translationPlugin(locale),
    enumerationPlugin,
    conditionPlugin,
    nestedPlugin,
    filePlugin,
    ...nodeProps.plugins ?? []
  ];
  return deepTransformNode(node, {
    ...nodeProps,
    plugins
  });
};
export {
  getContent
};
//# sourceMappingURL=getContent.mjs.map